import React, { useEffect, useState } from "react";
import styled from "styled-components";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import VideoCallOutlinedIcon from "@mui/icons-material/VideoCallOutlined";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ListIcon from "@mui/icons-material/List";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Upload from "./Upload";
import LogoutModal from "./LogoutModal";
import { Badge } from "@mui/material";
import NotifModal from "./NotifModal";
// import { io } from "socket.io-client";
import { getNotif, changeNotifState } from "../redux/apiCalls";
import logoImg from "../img/logo.png";
import { hideSuccess } from "../redux/menuSlice";
import SmMenu from "./SmMenu";

const Container = styled.div`
  position: fixed;
  top: 0;
  height: 56px;
  width: 100%;
  z-index: 999;
`;

const Wrapper = styled.div`
  padding: 0px 20px;
  background-color: ${({ theme }) => theme.bgLighter};
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: space-between;
`;
const Search = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  width: 40%;
  border-radius: 3px;
  padding: 5px;
  border: 1px solid #ccc;
  @media only screen and (max-width: 767px) {
    width: 20%;
    left: 0;
    right: 65px;
  }
`;
const Input = styled.input`
  border: none;
  outline: none;
  background-color: transparent;
  color: ${({ theme }) => theme.text};
  @media only screen and (max-width: 767px) {
    width: 80%;
  }
`;
const Button = styled.button`
  padding: 5px 15px;
  background-color: transparent;
  border: 1px solid #3ea6ff;
  color: #3ea6ff;
  border-radius: 3px;
  font-weight: 500;
  cursor: pointer;
  align-items: center;
  display: flex;
  gap: 5px;
  justify-self: flex-start;
`;

const User = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  font-weight: 500;
  color: ${({ theme }) => theme.text};
  @media only screen and (max-width: 767px) {
    gap: 14px;
  }
`;
const Avatar = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  cursor: pointer;
`;

const Logo = styled.div`
  display: flex;
  gap: 5px;
  color: ${({ theme }) => theme.text};
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 18px;
  cursor: pointer;
  @media only screen and (max-width: 767px) {
    gap: 8px;
  }
`;

const Img = styled.img`
  height: 25px;
`;

const Name = styled.span`
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;
const MyStyledButton = styled(MenuIcon)`
  margin-right: 5px;
`;

const MyStyledButton2 = styled(ListIcon)`
  margin-right: 5px;
`;

const MyStyledSearchButton = styled(SearchOutlinedIcon)`
  cursor: pointer;
  color: ${({ theme }) => theme.text};
`;

const Navbar = ({ darkMode, setDarkMode }) => {
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openNotifModal, setOpenNotifModal] = useState(false);
  const [smDisplay, setSmDisplay] = useState(false);
  const [openSmMenu, setOpenSmMenu] = useState(false);
  const [q, setQ] = useState("");
  // const [socket, setSocket] = useState(null);
  const dispatch = useDispatch();
  const { currentNotifications } = useSelector((state) => state.notification);
  const navigate = useNavigate();
  const { currentUser } = useSelector((state) => state.user);
  const newNotif = currentNotifications?.filter(
    (notif) => notif.isRead == false
  );

  // useEffect(() => {
  //   setSocket(io("ws://localhost:8900"));
  // }, []);

  // useEffect(() => {
  //   socket?.on("welcome", (message) => {
  //     console.log(message);
  //   });
  // }, [socket]);

  useEffect(() => {
    getNotif(dispatch);
  }, [dispatch, currentUser?._id]);

  const handleClick = (e) => {
    e.preventDefault();
    dispatch(hideSuccess());
  };

  useEffect(() => {
    if (window.innerWidth > 1024) {
      setSmDisplay(false);
    } else {
      setSmDisplay(true);
    }
  }, []);

  const handleSmClick = (e) => {
    e.preventDefault();
    setOpenSmMenu(!openSmMenu);
  };

  const AvatarContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `;
  const UserName = styled.span`
    font-size: 9px;
  `;

  return (
    <>
      <Container>
        <Wrapper>
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            <Logo>
              {smDisplay ? (
                <MyStyledButton2 onClick={handleSmClick}></MyStyledButton2>
              ) : (
                <MyStyledButton onClick={handleClick}></MyStyledButton>
              )}
              <Img src={logoImg} alt="img" />
              <Name>MoudTube</Name>
            </Logo>
          </Link>
          <Search>
            <Input
              placeholder="Search"
              onChange={(e) => setQ(e.target.value)}
            />

            <MyStyledSearchButton
              onClick={() => navigate(`/search?q=${q}`)}
            ></MyStyledSearchButton>
          </Search>
          {currentUser ? (
            <User>
              <Badge
                badgeContent={newNotif ? newNotif?.length : ""}
                color="error"
              >
                <NotificationsIcon
                  onClick={() => {
                    setOpenNotifModal(!openNotifModal);
                    changeNotifState(currentUser?._id);
                  }}
                  style={{ cursor: "pointer", width: "25px", height: "25px" }}
                />
              </Badge>

              <VideoCallOutlinedIcon
                onClick={() => {
                  setOpen(true);
                  document.body.style.overflow = "hidden";
                }}
                style={{ cursor: "pointer", width: "30px", height: "30px" }}
              />
              <AvatarContainer>
                <Avatar
                  onClick={() => {
                    setOpenModal(!openModal);
                  }}
                  src={
                    currentUser?.img
                      ? currentUser?.img
                      : "https://refugedulacdulou.com/wp-content/uploads/2019/01/avatar-anonyme.png"
                  }
                />
                <UserName>{currentUser?.name}</UserName>
              </AvatarContainer>
            </User>
          ) : (
            <Link to="signin" style={{ textDecoration: "none" }}>
              <Button>
                <AccountCircleOutlinedIcon />
                SIGN IN
              </Button>
            </Link>
          )}
        </Wrapper>
      </Container>
      {open && <Upload setOpen={setOpen} />}
      {openModal && (
        <LogoutModal setOpenModal={setOpenModal} currentUser={currentUser} />
      )}
      {openNotifModal && (
        <NotifModal
          currentNotifications={currentNotifications}
          setOpenNotifModal={setOpenNotifModal}
        />
      )}
      {openSmMenu && (
        <SmMenu
          openSmMenu={openSmMenu}
          setOpenSmMenu={setOpenSmMenu}
          currentUser={currentUser}
          darkMode={darkMode}
          setDarkMode={setDarkMode}
        />
      )}
    </>
  );
};

export default Navbar;
